// @flow
import { Outlet } from 'react-router';

const ServiceOverview = (): React$Node => {
  return <Outlet />;
};

export default ServiceOverview;
